
function remove(data, onUpdateIdSelected, idsSelected) {
    let idsFound = [];

    if (Array.isArray(data)) {
        data.forEach((row) => {
            if (Array.isArray(row.constructorList)) {
                row.constructorList.forEach((attribute) => {
                    if (attribute
                        && (attribute.columnType && (attribute.columnType.toUpperCase() === 'CHECKBOX'))
                        && (attribute.field && (attribute.field.toUpperCase() === 'ID'))) {
                        idsFound.push(attribute.argument);
                    }
                });
            }
        });
    }
    if (idsSelected && idsSelected.length > 0 && idsFound && idsFound.length > 0) {
        const filteredIds = idsSelected.filter((id) => idsFound.includes(id));
        const arraysAreDifferent =
            idsSelected.length !== filteredIds.length ||
            new Set(idsSelected).size !== new Set(filteredIds).size ||
            !filteredIds.every((id) => idsSelected.includes(id));

        if (arraysAreDifferent) {
            onUpdateIdSelected(filteredIds);
        }
    }
}


export default { remove };
